/**
 * Versanddienste fuer die Versandrueckmeldung am Lieferschein.
 *
 * Der Schluessel wird gespeichert; das Muster liefert den Link zur
 * Sendungsverfolgung, in das die Sendungsnummer eingesetzt wird. Ohne Muster
 * gibt es keinen Link (Spedition, Abholung, eigene Zustellung).
 */
export const CARRIERS = [
    { code: 'dhl', label: 'DHL', trackingUrl: 'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode={nr}' },
    { code: 'dpd', label: 'DPD', trackingUrl: 'https://tracking.dpd.de/status/de_DE/parcel/{nr}' },
    { code: 'ups', label: 'UPS', trackingUrl: 'https://www.ups.com/track?loc=de_DE&tracknum={nr}' },
    { code: 'gls', label: 'GLS', trackingUrl: 'https://gls-group.eu/DE/de/paketverfolgung?match={nr}' },
    { code: 'fedex', label: 'FedEx / TNT', trackingUrl: 'https://www.fedex.com/fedextrack/?trknbr={nr}' },
    { code: 'dachser', label: 'Dachser (Spedition)', trackingUrl: 'https://elogistics.dachser.com/shp2s/?nve={nr}' },
    { code: 'spedition', label: 'Spedition (sonstige)' },
    { code: 'eigen', label: 'Eigene Zustellung' },
    { code: 'abholung', label: 'Abholung durch Kunden' },
];
export function carrierLabel(code) {
    return CARRIERS.find((entry) => entry.code === code)?.label ?? code;
}
/** Link zur Sendungsverfolgung oder null, wenn der Dienst keinen hat. */
export function trackingLink(code, trackingNumber) {
    const carrier = CARRIERS.find((entry) => entry.code === code);
    const number = (trackingNumber ?? '').trim();
    if (!carrier?.trackingUrl || !number)
        return null;
    return carrier.trackingUrl.replace('{nr}', encodeURIComponent(number));
}
//# sourceMappingURL=shipping.js.map